import { jsx as _jsx } from "react/jsx-runtime";
// Spacing values in rem (based on 17px line-height with 13px base font)
const SPACING_MAP = {
    xs: '0.277rem', // 3.6px
    sm: '0.523rem', // 6.8px
    md: '0.923rem', // 12px
    lg: '1.308rem', // 17px
    xl: '1.962rem', // 25.5px
    xxl: '2.615rem', // 34px
    xxxl: '3.269rem', // 42.5px
};
const translateValue = (value) => {
    if (value === null || value === undefined)
        return '0';
    if (value === 'auto')
        return 'auto';
    if (typeof value === 'number')
        return `${value / 13}rem`;
    return SPACING_MAP[value] || '0';
};
const translateSpacing = (values) => {
    if (!values)
        return null;
    if (Array.isArray(values)) {
        return values.map(translateValue).join(' ');
    }
    if (typeof values === 'string' && SPACING_MAP[values]) {
        return SPACING_MAP[values];
    }
    return null;
};
const Spacing = ({ align = 'left', alignItems, children, className = '', display = 'block', flex, float = 'none', margin, maxWidth = 'none', padding, width = 'auto', }) => {
    const alignClasses = {
        left: 'text-left',
        center: 'text-center',
        right: 'text-right',
    };
    const floatClasses = {
        left: 'float-left',
        right: 'float-right',
        none: 'float-none',
    };
    const classes = [alignClasses[align], floatClasses[float], className]
        .filter(Boolean)
        .join(' ');
    const style = {};
    // Only set display if not using Tailwind display classes
    if (!className.match(/\b(flex|grid|inline|block|hidden)\b/)) {
        style.display = display;
    }
    if (flex !== undefined)
        style.flex = flex;
    if (alignItems)
        style.alignItems = alignItems;
    if (margin) {
        // If it's a plain CSS string (contains spaces or 'px'), use directly
        if (typeof margin === 'string' &&
            (margin.includes(' ') || margin.includes('px'))) {
            style.margin = margin;
        }
        else {
            const marginValue = translateSpacing(margin);
            if (marginValue)
                style.margin = marginValue;
        }
    }
    if (maxWidth !== 'none') {
        style.maxWidth =
            typeof maxWidth === 'number' ? `${maxWidth / 13}rem` : maxWidth;
    }
    if (padding) {
        // If it's a plain CSS string (contains spaces or 'px'), use directly
        if (typeof padding === 'string' &&
            (padding.includes(' ') || padding.includes('px'))) {
            style.padding = padding;
        }
        else {
            const paddingValue = translateSpacing(padding);
            if (paddingValue)
                style.padding = paddingValue;
        }
    }
    if (width !== 'auto') {
        style.width = typeof width === 'number' ? `${width / 13}rem` : width;
        // Center block element with fixed width when align is center
        if (align === 'center') {
            style.marginLeft = 'auto';
            style.marginRight = 'auto';
        }
    }
    return (_jsx("div", { className: classes, style: style, children: children }));
};
export default Spacing;
//# sourceMappingURL=spacing.js.map